import { AnalyticsTypes } from '../../../middleware/google-analytics';
import {
    trackShowModalCategory,
    trackBookOutOfNetwork,
    trackClickedCloseModal,
    trackClickedFindDoctorButton,
} from './constants';
import { createGaActionCreatorWithDetails } from '../../utils/createGaActionCreator';

const ACTION_PREFIX = '@@bookingcontainer';

const SHOW_SECURE_HEADER = `${ACTION_PREFIX}/SET_SECURE_HEADER`;
const SHOW_MODAL = `${ACTION_PREFIX}/SHOW_MODAL`;
const HIDE_MODAL = `${ACTION_PREFIX}/HIDE_MODAL`;

const TRACK_BOOK_OUT_OF_NETWORK_ANYWAY = `${ACTION_PREFIX}/TRACK_BOOK_OUT_OF_NETWORK_ANYWAY`;
const TRACK_UPDATE_INSURANCE_AFTER_OUT_OF_NETWORK_WARN = `${ACTION_PREFIX}/TRACK_UPDATE_INSURANCE_AFTER_OUT_OF_NETWORK_WARN`;
const TRACK_CLICKED_SEARCH_FOR_DOCTOR = `${ACTION_PREFIX}/TRACK_CLICKED_SEARCH_DOCTOR`;
const TRACK_CLOSED_MODAL = `${ACTION_PREFIX}/TRACK_CLICKED_CLOSE_MODAL`;

export const BookingContainerActions = {
    SHOW_SECURE_HEADER,
    SHOW_MODAL,
    HIDE_MODAL,
    TRACK_BOOK_OUT_OF_NETWORK_ANYWAY,
    TRACK_UPDATE_INSURANCE_AFTER_OUT_OF_NETWORK_WARN,
    TRACK_CLICKED_SEARCH_FOR_DOCTOR,
    TRACK_CLOSED_MODAL,
};

export const showSecureHeader = showSecure => ({
    type: BookingContainerActions.SHOW_SECURE_HEADER,
    showSecureHeader: showSecure,
});

export function showModal(modalContent) {
    const action = {
        type: BookingContainerActions.SHOW_MODAL,
        modalContent,
    };

    if (modalContent.gaAction) {
        action.meta = {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                category: trackShowModalCategory,
                action: modalContent.gaAction,
            },
        };

        if (modalContent.trackingMessage) {
            action.meta.analytics.eventDetails = {
                Message: modalContent.trackingMessage,
            };
        }
    }
    return action;
}

export const hideModal = () => ({
    type: BookingContainerActions.HIDE_MODAL,
});

export const trackBookOutOfNetworkAnyway = eventDetails =>
    createGaActionCreatorWithDetails(
        TRACK_BOOK_OUT_OF_NETWORK_ANYWAY,
        trackShowModalCategory,
        trackBookOutOfNetwork,
        eventDetails
    );

export const trackClickCloseModal = eventDetails =>
    createGaActionCreatorWithDetails(
        TRACK_CLOSED_MODAL,
        trackShowModalCategory,
        trackClickedCloseModal,
        eventDetails
    );

export const trackClickFindDoctorsButton = (procedureId, eventDetails) =>
    createGaActionCreatorWithDetails(
        TRACK_CLICKED_SEARCH_FOR_DOCTOR,
        trackShowModalCategory,
        `${trackClickedFindDoctorButton}: ${procedureId}`,
        eventDetails
    );
